import { georefToWgs84, isLocal } from './georef';

const finite = (v) => typeof v === 'number' && Number.isFinite(v);
const validLonLat = (lon, lat) => finite(lon) && finite(lat) && Math.abs(lon) <= 180 && Math.abs(lat) <= 90;
const present = (v) => v !== null && v !== undefined && v !== '';

/**
 * A representative [lon, lat] for a dataset row, or null when it has no placed location:
 * explicit longitude/latitude, a georeferenced survey (centre of the line when the spacing
 * and electrode count are known, else its origin), or a [w, s, e, n] bbox on the row or in
 * its metadata.
 */
export function datasetLonLat(d) {
  if (!d) return null;
  if (present(d.longitude) && present(d.latitude) && validLonLat(Number(d.longitude), Number(d.latitude))) {
    return [Number(d.longitude), Number(d.latitude)];
  }
  const m = d.metadata || {};
  const g = m.georef;
  if (g && !isLocal(g) && g.transform) {
    const half = finite(m.spacing) && finite(m.n_electrodes) ? (m.spacing * (m.n_electrodes - 1)) / 2 : 0;
    try {
      const [lon, lat] = georefToWgs84(g, half, 0);
      if (validLonLat(lon, lat)) return [lon, lat];
    } catch { /* unusable CRS: fall through to a bbox */ }
  }
  for (const b of [d.bbox, m.bbox, m.bounds]) {
    if (Array.isArray(b) && b.length === 4 && b.every(finite)) {
      const lon = (b[0] + b[2]) / 2, lat = (b[1] + b[3]) / 2;
      if (validLonLat(lon, lat)) return [lon, lat];
    }
  }
  return null;
}

/** Split datasets into placed ones ({ dataset, lon, lat }) and a count of those without a location. */
export function locateDatasets(datasets) {
  const placed = [];
  let skipped = 0;
  (datasets || []).forEach((dataset) => {
    const p = datasetLonLat(dataset);
    if (p) placed.push({ dataset, lon: p[0], lat: p[1] }); else skipped += 1;
  });
  return { placed, skipped };
}
